import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../abstract/base.service';
import { SupportTicketThread } from '../data-models/support-ticket-thread.model';
import { SupportTicketThreadRequest } from '../request-models/support-ticket-thread-request.model';

/**
 * A support ticket's conversation: `/support-tickets/:ticketId/threads` (hub `user-support-tickets-controller.ts`).
 * Callers go through `SupportTicketService`, which keeps the ticket-level API. Rejects with an `ApiError`.
 */
@Injectable({
  providedIn: 'root'
})
export class SupportTicketThreadService extends BaseService<SupportTicketThread> {
  constructor() {
    super('threads', SupportTicketThread);
  }

  /** The ticket's conversation history. */
  listForTicket(ticketId: string): Observable<SupportTicketThread[]> {
    return this.getMany({ prefix: ticketPrefix(ticketId) });
  }

  /** Add a reply to the ticket. */
  addToTicket(ticketId: string, body: SupportTicketThreadRequest): Observable<SupportTicketThread | null> {
    return this.create(body, { prefix: ticketPrefix(ticketId) });
  }
}

function ticketPrefix(ticketId: string): string[] {
  return ['support-tickets', ticketId];
}
